var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M10.5,0h-8A2.5,2.5,0,0,0,0,2.5v17A2.5,2.5,0,0,0,2.5,22h8A2.5,2.5,0,0,0,13,19.5V2.5A2.5,2.5,0,0,0,10.5,0Zm-4,21A1.5,1.5,0,1,1,8,19.5,1.5,1.5,0,0,1,6.5,21ZM11,17H2V3h9Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }